import _ from 'lodash'

const getLayerId = (symbol) => _.get(symbol, 'id', '')

export { getLayerId }
